import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Tooltip from '@material-ui/core/Tooltip';
import { CSVLink } from 'react-csv';
import {
  RENT_CANCEL,
  RENT_ENDED,
  RENT_EXTENDED,
  RENT_IN_PROGRESS,
} from '../../constants/RentStates';
import KobooTablePagination from '../Layout/KobooTablePagination.jsx';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import RentRow from './RentRow';
import { getCSVRents, getRents } from '../../store/rents/actions';
import Loader from '../Layout/Loader';
import { getUsers } from '../../store/users/actions';
import { getOpinionValue } from '../../services/RentService';
import FeedbackDialog from '../Feedback/FeedbackDialog';
import { Grid } from '@material-ui/core';
import KobooButton from '../Layout/KobooButton';

/* eslint-disable no-bitwise */

const styles = theme => (
  {
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
      overflowX: 'auto',
    },
    dialogContent: {
      textAlign: 'center',
    },
    table: {
      minWidth: 700,
    },
    fabProgress: {
      color: 'primary',
      position: 'absolute',
      top: -6,
      left: -6,
      zIndex: 1,
    },
  }
);

const columnData = [
  {
    id: 'state',
    numeric: false,
    disablePadding: false,
    label: 'État',
  },
  {
    id: 'start_date',
    numeric: false,
    disablePadding: false,
    label: 'Date de début',
  },
  {
    id: 'rent_price',
    numeric: true,
    disablePadding: false,
    label: 'Prix',
  },
  {
    id: 'bike_id',
    numeric: true,
    disablePadding: false,
    label: 'N° Vélo',
  },
  {
    id: 'renterName',
    numeric: false,
    disablePadding: false,
    label: 'Loueur',
  },
  {
    id: 'siteName',
    numeric: false,
    disablePadding: false,
    label: 'Site départ',
  },
  {
    id: 'endSiteName',
    numeric: false,
    disablePadding: false,
    label: 'Site arrivée',
  },
  {
    id: 'duration',
    numeric: false,
    disablePadding: false,
    label: 'Durée',
  },
  {
    id: 'client_mail',
    numeric: false,
    disablePadding: false,
    label: 'Email',
  },
  {
    id: 'client_phone',
    numeric: false,
    disablePadding: false,
    label: 'Telephone',
  },
  {
    id: 'user_feedback',
    label: 'Avis client',
    numeric: false,
    disablePadding: false,
  },
];

export function sec2str(t) {
  const d = Math.floor(t / 86400);
  const h = (
    `0${Math.floor(t / 3600) % 24}`
  ).slice(-2);
  const m = (
    `0${Math.floor(t / 60) % 60}`
  ).slice(-2);
  const s = (
    `0${t % 60}`
  ).slice(-2);
  return (
      d > 0
        ? `${d} jours `
        : ''
    )
    + (
      h > 0
        ? `${h}h`
        : '00h'
    )
    + (
      m > 0
        ? `${m}m`
        : '00m'
    )
    + (
      `${s}s`
    );
}

export class RentTable extends Component {
  static savedUsers = null;

  constructor(props, context) {
    super(props, context);
    this.state = {
      order: 'asc',
      orderBy: 'start_date',
      data: [],
      page: 0,
      rowsPerPage: 500,
      role: ROLE_USER,
      open: false,
      modalFeedback: '',
      modalFeedbackOpinion: '',
    };
  }

  handleClose = () => {
    this.setState(
      {
        open: false,
        modalFeedback: '',
        modalFeedbackOpinion: '',
      },
    );
  };

  showFeedback = (message, opinion) => {
    this.setState(
      {
        open: true,
        modalFeedback: message,
        modalFeedbackOpinion: opinion,
      },
    );
  };

  static sort(a, b, property, order) {
    let prop1,
      prop2;
    if (property === 'user_feedback') {
      prop1 = getOpinionValue(a);
      prop2 = getOpinionValue(b);
    } else if (property === 'bike_id') {
      prop1 = (
        a.bikeNumber !== null && a.bikeNumber !== undefined
      )
        ? a.bikeNumber
        : -1;
      prop2 = (
        b.bikeNumber !== null && b.bikeNumber !== undefined
      )
        ? b.bikeNumber
        : -1;
    } else if (property === 'duration') {
      prop1 = (
        a.end_date
          ? a.end_date
          : new Date() / 1e3 | 0
      ) - a.start_date;
      prop2 = (
        b.end_date
          ? b.end_date
          : new Date() / 1e3 | 0
      ) - b.start_date;
    } else if (property === 'client_mail') {
      prop1 = (RentTable.savedUsers && a.user_id in RentTable.savedUsers)
        ? RentTable.savedUsers[a.user_id].email
        : '';
      prop2 = (RentTable.savedUsers && b.user_id in RentTable.savedUsers)
        ? RentTable.savedUsers[b.user_id].email
        : '';
    } else if (property === 'client_phone') {
      const phone1 = (RentTable.savedUsers && a.user_id in RentTable.savedUsers)
        ? RentTable.savedUsers[a.user_id].mobile
        : '';
      const phone2 = (RentTable.savedUsers && b.user_id in RentTable.savedUsers)
        ? RentTable.savedUsers[b.user_id].mobile
        : '';
      prop1 = phone1.replace(' ', '').replace(':', '').replace('-', '').replace('/', '');
      prop2 = phone2.replace(' ', '').replace(':', '').replace('-', '').replace('/', '');
    } else {
      prop1 = (
        a[property] !== null && a[property] !== undefined
      )
        ? a[property]
        : -1;
      prop2 = (
        b[property] !== null && b[property] !== undefined
      )
        ? b[property]
        : -1;
    }
    if (order === 'asc') {
      return prop1 > prop2
        ? -1
        : 1;
    }
    return prop1 < prop2
      ? -1
      : 1;
  }

  static setRentState = (rent) => {
    if (rent.end_date && (
      rent.rent_price === 0 || !rent.rent_price
    )) {
      rent.state = rent.next_rent_id
        ? RENT_EXTENDED
        : RENT_CANCEL;
    } else if (rent.end_date) {
      rent.state = RENT_ENDED;
    } else {
      rent.state = RENT_IN_PROGRESS;
    }
    return rent;
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      if (!props.rents && !props.pending) {
        props.getRents(props.authUser.ma, role, state.rowsPerPage, state.page, props.renters);
      }
      if (!props.users && !props.pendingUsers) {
        props.getUsers();
      }
      if (!props.csv_rents && !props.pending) {
        props.getCSVRents(props.authUser.ma);
      }
      newState = {
        ...newState,
        role,
      };
      if (props.users && !props.pendingUsers && !RentTable.savedUsers) {
        RentTable.savedUsers = props.users;
      }
    }
    if (props.rents && props.bikes && props.renters && props.sites) {
      const rentArray = [];
      props.rents.forEach((rent) => {
        const foundBike = props.bikes.find(bike => bike.id === rent.bike_id);
        if (foundBike) {
          rent.bikeNumber = foundBike.number;

          rent.siteName = '';
          rent.renterName = '';
          if (rent.start_site && props.sites.find(site => site.id === rent.start_site.id)) {
            const foundStartSite = props.sites.find(site => site.id === rent.start_site.id);
            if (foundStartSite) {
              rent.siteName = foundStartSite.name;
              rent.renterName = props.renters
                .find(renter => renter.id === foundStartSite.renter_info_id).name;
            }
          } else if (foundBike.site_id && props.sites.find(site => site.id === foundBike.site_id)) {
            rent.siteName = props.sites.find(site => site.id === foundBike.site_id).name;
          }
          if (rent.end_site && props.sites.find(site => site.id === rent.end_site.id)) {
            rent.endSiteName = props.sites.find(site => site.id === rent.end_site.id).name;
          }
        }

        rentArray.push(RentTable.setRentState(rent));
      });
      newState = {
        ...newState,
        data: rentArray.sort((a, b) => RentTable.sort(a, b, state.orderBy, state.order)),
      };
    }
    return newState;
  }

  static propTypes = {
    classes: PropTypes.object.isRequired,
    bikes: PropTypes.array.isRequired,
    renters: PropTypes.array.isRequired,
    sites: PropTypes.array.isRequired,
  };

  createSortHandler = property => () => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === orderBy && this.state.order === order) {
      order = 'asc';
    }
    const data = this.state.data.sort((a, b) => RentTable.sort(a, b, orderBy, order));
    this.setState({
      data,
      order,
      orderBy,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
    const role = this.props.roles[this.props.authUser.uid];
    this.props.getRents(this.props.authUser.ma,
      role,
      this.state.rowsPerPage,
      page,
      this.props.renters,
    );
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
    const role = this.props.roles[this.props.authUser.uid];
    this.props.getRents(this.props.authUser.ma,
      role,
      event.target.value,
      this.state.page,
      this.props.renters,
    );
  };

  clickDownloadCsv = (event) => {
    event.stopPropagation();
    document.getElementById('csv_link_rent').click();
  };

  render() {
    let columns = [...columnData];
    if (this.state.role < ROLE_ADMIN) {
      columns.splice(columnData.findIndex(column => column.id === 'renterName'), 1);
    }

    const {
      classes,
      pending,
    } = this.props;

    const {
      data,
      rowsPerPage,
      page,
      order,
      orderBy,
    } = this.state;

    return (
      <React.Fragment>
        <Grid
          container
          direction={'row-reverse'}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <KobooButton type="button" onClick={this.clickDownloadCsv}>
              Télécharger le CSV
            </KobooButton>
          </Grid>
        </Grid>
        <CSVLink
          id="csv_link_rent"
          filename={`locations-${new Date().getTime()}.csv`}
          data={this.props.csv_rents || ''}

          style={{ display: 'none' }}
        >-</CSVLink>
        <div className={classes.tableWrapper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {columns.map(column => (
                  <TableCell
                    key={column.id}
                    padding={column.disablePadding
                      ? 'none'
                      : 'normal'}
                    sortDirection={orderBy === column.id
                      ? order
                      : false}>
                    <Tooltip
                      title="Trier"
                      placement={column.numeric === true
                        ? 'bottom-end'
                        : 'bottom-start'}
                      enterDelay={300}>
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={order}
                        onClick={this.createSortHandler(column.id)}>
                        {column.label}
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                ), this)}
                {this.state.role >= ROLE_ADMIN
                && <TableCell  style={{ width: '60px' }} key={'actions'} padding={'normal'}>
                  {' '}
                </TableCell>
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {pending == true
              && <tr>
                <td colSpan={columns.length}>
                  <Loader />
                </td>
              </tr>}
              {pending == false && Array.isArray(data) && data.length > 0
              && data.slice(page * rowsPerPage,
                (
                  page * rowsPerPage
                ) + rowsPerPage,
              ).map(rent => (
                <RentRow
                  key={rent.id}
                  rent={rent}
                  showFeedback={this.showFeedback}
                />
              ))}
              {pending == false  && Array.isArray(data) && data.length <= 0
              && <tr>
                <td colSpan={columns.length}>
                  <Typography variant="subtitle1">Aucune location</Typography>
                </td>
              </tr>}
            </TableBody>
          </Table>
        </div>
        <KobooTablePagination
          numberOfItems={this.props.nb_rents}
          rowsPerPage={rowsPerPage}
          label="Locations par page"
          page={page}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
        <FeedbackDialog
          open={this.state.open}
          handleClose={this.handleClose}
          modalFeedback={this.state.modalFeedback}
          modalFeedbackOpinion={this.state.modalFeedbackOpinion}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    pendingUsers: state.users.pending,
    users: state.users.content,
    roles: state.roles.content,
    sending: state.rents.sending,
    pending: state.rents.pending | state.rents.csv_pending,
    rents: state.rents.content,
    nb_rents: state.rents.nb_rents,
    csv_rents: state.rents.csv_rents,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps,
    {
      getRents,
      getCSVRents,
      getUsers,
    },
  ),
)(RentTable);



// WEBPACK FOOTER //
// ./src/components/Rent/RentTable.jsx